import { Paper, Stack, Typography } from '@mui/material'
import { CarrierVisitDirection } from '@planning/app/api'
import { ChangeTransportSubFormStore } from '@planning/components/organisms/ChangeTransportSubForm'
import { OrderFormStore } from '@planning/pages/Order/V2/stores/OrderFormStore'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { OrderTransportCard } from '../organisms/OrderTransportCard'

export const OrderTransportStep = observer(
  (props: {
    inboundTransportStore: ChangeTransportSubFormStore
    outboundTransportStore: ChangeTransportSubFormStore
    formStore: OrderFormStore
    disabled?: boolean
  }) => {
    const { inboundTransportStore, outboundTransportStore, formStore, disabled } = props
    const { t } = useTranslate()

    return (
      <Stack spacing={2}>
        <Typography variant='subtitle1'>{t('addTransport', 'Add transport')} </Typography>
        <Paper variant='outlined' sx={{ p: '1rem' }}>
          <Stack spacing={2}>
            <OrderTransportCard
              title={t('inboundTransport', 'Inbound transport')}
              transportStore={inboundTransportStore}
              formStore={formStore}
              direction={CarrierVisitDirection.Inbound}
              hideContainerReleasePrompt
              disabled={disabled}
            />
            <OrderTransportCard
              title={t('outboundTransport', 'Outbound transport')}
              formStore={formStore}
              direction={CarrierVisitDirection.Outbound}
              disabled={disabled}
              transportStore={outboundTransportStore}
            />
          </Stack>
        </Paper>
      </Stack>
    )
  },
)
